var _defs, _path, _polygon, _path2, _path3, _path4, _polygon2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 950.65 274.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #0a0203;\n            }\n\n            .cls-2 {\n                fill: #fff;\n            }\n\n            .cls-3 {\n                fill: #0069aa;\n            }\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.71,59.73h-73l-25,124.19H365.11v33.92h54.61l7.77-38.26H448.9l7.77,38.26h54.61V183.92H499.72ZM438.19,89.15l10.43,63.07H427.77Z",
    transform: "translate(-29.77)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "595.71 85.09 595.71 94.2 595.71 137.3 554.82 60.29 500.2 60.29 500.2 94.2 511.72 94.2 511.72 183.92 500.2 183.92 500.2 217.84 511.72 217.84 554.82 217.84 554.82 183.92 554.82 140.83 595.71 217.84 638.81 217.84 650.33 217.84 650.33 183.92 638.81 183.92 638.81 94.2 650.33 94.2 650.33 60.29 595.71 60.29 595.71 85.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M928.8,60.29H873.63a31.09,31.09,0,0,0-31,31v95.57a31.09,31.09,0,0,0,31,31H928.8a31.09,31.09,0,0,0,31-31V91.28A31.08,31.08,0,0,0,928.8,60.29ZM914.27,185.12H888.58V93.44h25.69v91.68Z",
    transform: "translate(-29.77)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M786.67,60.29H735.88a31.09,31.09,0,0,0-31,31v95.57a31.09,31.09,0,0,0,31,31h80.66v-58h-40v25.27H750.83V93.44h25.69v17.13h40V60.29H786.67Z",
    transform: "translate(-29.77)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.15,233.62L279.42,253.4H120.29L85.56,233.62l-33-172.5L86.95,21.22H312.76l34.42,39.91Z",
    transform: "translate(-29.77)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "280.38 59.73 211.76 59.73 211.76 93.49 222.91 93.49 211.18 163.39 188.66 59.73 175.09 59.73 165.08 59.73 151.52 59.73 129 163.39 117.27 93.49 128.42 93.49 128.42 59.73 59.8 59.73 59.8 93.49 71.79 93.49 94.45 217.84 150.77 217.84 170.09 128.92 189.41 217.84 245.72 217.84 268.38 93.49 280.38 93.49 280.38 59.73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.94,55L322.48,0H77.23L29.77,55h0L66.56,247.22l48.11,27.39H285l48.11-27.39L369.94,55h0ZM314.15,233.62L279.42,253.4H120.29L85.56,233.62l-33-172.5L86.95,21.22H312.76l34.42,39.91Z",
    transform: "translate(-29.77)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M961.06,50.71a9.68,9.68,0,1,1,9.7,9.58A9.54,9.54,0,0,1,961.06,50.71Zm9.7,8a8,8,0,1,0-7.78-8A7.71,7.71,0,0,0,970.76,58.7Zm-2-2.45h-1.67v-11h4.19c2.6,0,3.89,1,3.89,3.13a2.87,2.87,0,0,1-2.86,3l3.13,4.85h-1.87l-2.91-4.78h-1.92v4.78Zm2-6.19c1.42,0,2.68-.1,2.68-1.79,0-1.36-1.24-1.62-2.4-1.62h-2.27v3.41h2Z",
    transform: "translate(-29.77)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWanco);
export default __webpack_public_path__ + "static/media/Wanco.b0ef81a54a0a586d8ff80643470f173b.svg";
export { ForwardRef as ReactComponent };